import { AddButton } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { ProjectTypeEnum } from "@src/__generated__/urql-graphql";
import { observer } from "mobx-react-lite";
import { useStore } from "../store";

interface CategoryHeaderProps {
  title: string;
  onAdd: () => void;
}

const CategoryHeader = ({ title, onAdd }: CategoryHeaderProps) => {
  const { project } = useStore();
  return (
    <div className="flex items-center justify-between">
      <h3 className="font-bold text-2xl">{title}</h3>
      <AddButton
        onClick={onAdd}
        disabled={project?.type === ProjectTypeEnum.TimeMaterials}
      >{t`Add new Item`}</AddButton>
    </div>
  );
};

export default observer(CategoryHeader);
